export default {
  PORTAL_ELEMENT_ID: 'portal-root',
  CONFIRMATION_ELEMENT_ID: 'confirmation-root',
  APP_ELEMENT_ID: 'root',
  ...process.env
};
